//global imports
import React, { FC, useState, useEffect, useRef} from "react";
import { Input, Tooltip, InputNumber, Space, Button, DatePicker, Select, Modal, Form, Checkbox , notification} from "antd";
import moment from "moment";
import { SearchOutlined,UpOutlined, DownOutlined, CloseOutlined} from "@ant-design/icons";
import { cloneDeep, get, isEmpty, noop } from "lodash";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import InputMask from "react-input-mask";

//local imports
import { LeftArrow, RightArrow } from "@pages/member-details/member-tabs/arrows";
import usePreventBodyScroll from "@pages/member-details/member-tabs/usePreventBodyScroll";
import {getClientName, getFormateForClient , formatDisplayDate , formatDateWithoutConversion} from "@utils/helpers";
import { dateFormatConfig } from "@utils/constants";
import {FilterTypes , CriteriaDropdown} from './constant';
import "./colFilters.scss";
import Icon from "@assets/icon_config";
import { useSorter } from "@utils/customHooks";

const { RangePicker } = DatePicker;
type scrollVisibilityApiType = React.ContextType<typeof VisibilityContext>;
const {CRITERIA , MSELDRPDWN , FREETXT , DATE , DOLLAR_CRITERIA , DATETIME , CUSTOM_DATE} = FilterTypes;
//function component for normal search filter
const FreeText: FC<any> = ({ item, inputref, noData, visible, filteredInfo, handleFilters }: any) => {
  const [searchValue, setSearchValue] = useState(get(filteredInfo , `${item.dataIndex}.value[0]` , ''));

  const handleReset = () => {
    setSearchValue("");
    if (inputref.current) {
      inputref.current.focus();
    }
  }

  useEffect(() => {
    setSearchValue(get(filteredInfo , `${item.dataIndex}.value[0]` , ''));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const handleSearch = () => {
    let filters = cloneDeep(filteredInfo);
    if (searchValue) {
      filters = { ...filters, [item.dataIndex]: { type: item.type, displayName: item.displayName, value: [searchValue] } };
    } else {
      delete filters[item.dataIndex];
    }
    handleFilters({filters});
  };

  return (
    <div>
      <Input
        ref={inputref}
        style={{ marginBottom: 8, display: "block" }}
        value={searchValue}
        // disabled={noData}
        placeholder={`Search ${item.displayName}`}
        onChange={(e) => {
          setSearchValue(e.target.value);
        }}
        onPressEnter={(e) => {
          handleSearch();
          e.stopPropagation();
        }}
      />
      <Space>
        <Button
          onClick={() => {
            handleReset();
          }}
          size="small"
          style={{ width: 90 }}
          // disabled={noData && !objectValuesChecker(columnSearchInfo)}
        >
          Reset
        </Button>
        <Button
          type="primary"
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}
          // disabled={noData && !objectValuesChecker(columnSearchInfo)}
          onClick={(e) => {
            handleSearch();
          }}
        >
          Search
        </Button>
      </Space>
    </div>
  );
};

//function component for criteria filter
const Criteria = ({ filteredInfo, item, visible, handleFilters }: any) => {
  const inputRef = useRef<any>(null);
  const secondInputRef = useRef<any>(null);

  const [x, setX] = useState<any>({ filterType: get(filteredInfo , `${item.dataIndex}.value[0].filterType` , 'Deselect'), filterValues: get(filteredInfo , `${item.dataIndex}.value[0].filterValues` , []) });
  const [form] = Form.useForm();
  const handleCriteriaChange = (value: any) => {
    let filters = cloneDeep(filteredInfo);
    if (value?.filterType === "Deselect") {
      delete filters[item.dataIndex];
    } else {
      filters = { ...filters, [item.dataIndex]: { type: item.type, displayName: item.displayName, value: [value] } };
    }
    handleFilters({ filters });
  };

  useEffect(() => {
    setX({ filterType: get(filteredInfo , `${item.dataIndex}.value[0].filterType` , 'Deselect'), filterValues: get(filteredInfo , `${item.dataIndex}.value[0].filterValues` , []) });
    form.setFieldsValue({ input1: x.filterValues?.[0], input2: x.filterValues?.[1] });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  useEffect(() => {
    inputRef.current?.focus();
  }, [x.filterType]);

  return (
    <div className="column_filter__criteria">
      <Select
        style={{ width: "12rem" }}
        placeholder={"Select"}
        onChange={(value) => {
          setX({ ...x, filterType: value, filterValues: [] });
          form.setFieldsValue({ input1: undefined, input2: undefined });
        }}
        value={x.filterType || "Deselect"}
        className="column_filter__criteria__select"
      >
        {CriteriaDropdown.map((option : any) => {
          return (
            <Select.Option value={option}>{option}</Select.Option>
          )
        })}
      </Select>
      <Form
        form={form}
        name="edit"
        layout="vertical"
        onFinish={(values) => {
          handleCriteriaChange(x);
        }}
      >
        {!isEmpty(x.filterType) && x.filterType !== "Deselect" ? (
          x.filterType === "Between" || x.filterType === "Not Between" ? (
            <div className="column_filter__criteria__range">
              <Form.Item
                name="input1"
                className="ui-edit-input__form__item "
                rules={[
                  {
                    required: true,
                    message: " ",
                  },
                ]}
              >
                <InputNumber
                  ref={inputRef}
                  name="input1"
                  placeholder="0.00"
                  value={x.filterValues?.[0]}
                  onChange={(value) => {
                    setX({ ...x, filterValues: [value, x.filterValues?.[1]] });
                  }}
                  onKeyDown={(e) => {
                    if (e.keyCode === 9) {
                      e.stopPropagation();
                      e.preventDefault();
                      secondInputRef.current?.focus();
                     
                    }
                  }}
                  onPressEnter={(e) => {
                    e.stopPropagation();
                    secondInputRef.current?.focus();
                  }}
                />
              </Form.Item>{" "}
              -{" "}
              <Form.Item
                name="input2"
                className="ui-edit-input__form__item "
                rules={[
                  {
                    required: true,
                    message: " ",
                  },
                ]}
              >
                <InputNumber
                  ref={secondInputRef}
                  name="input2"
                  placeholder="0.00"
                  value={x.filterValues?.[1]}
                  onChange={(value) => {
                    setX({ ...x, filterValues: [x.filterValues?.[0], value] });
                  }}
                  onKeyDown={(e) => {
                    if (e.keyCode === 9) {
                      e.stopPropagation();
                      e.preventDefault()
                      inputRef.current?.focus();
                    }
                  }}
                  onPressEnter={(e) => {
                    e.stopPropagation();
                    form && form.submit();
                  }}
                />
              </Form.Item>
            </div>
          ) : (
            <Form.Item
              name="input1"
              className="ui-edit-input__form__item "
              rules={[
                {
                  required: true,
                  message: " ",
                },
              ]}
            >
              <InputNumber
                ref={inputRef}
                name="input1"
                placeholder="0.00"
                className="column_filter__criteria__input"
                value={x.filterValues?.[0]}
                onChange={(value) => {
                  setX({ ...x, filterValues: [value] });
                }}
                onPressEnter={(e) => {
                  e.stopPropagation();
                }}
              />
            </Form.Item>
          )
        ) : null}
      </Form>
      {!isEmpty(x.filterType) && (
        <div className="column_filter__criteria__btn">
          <Space>
            <Button
              onClick={() => {
                setX({ filterType: "Deselect", filterValues: [] });
              }}
              size="small"
              style={{ width: 90 }}
            >
              {" "}
              Reset{" "}
            </Button>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
              onClick={() => {
                form && form.submit();
              }}
            >
              {" "}
              Search{" "}
            </Button>
          </Space>
        </div>
      )}
    </div>
  );
};

//function component for date range filter
const DateRange: FC<any> = ({ item, inputref ,filteredInfo, visible, handleFilters }: any) => {
  const value = get(filteredInfo , `${item.dataIndex}.value`);
  const [range, setRange] = useState<any>(value?.[0] && value?.[1] ? [moment.utc(moment(value[0]).format("MM/DD/YYYY")), moment.utc(moment(value[1]).format("MM/DD/YYYY"))] : undefined);

  useEffect(() => {
    setRange(value?.[0] && value?.[1] ? [moment.utc(moment(value[0]).format("MM/DD/YYYY")), moment.utc(moment(value[1]).format("MM/DD/YYYY"))] : undefined);
  }, [value, visible]);

  const dateRangeChange = () => {
    const startDate = range && range.length > 0 ? range[0].format("YYYY-MM-DD") : "";
    const endDate = range && range.length > 0 ? range[1].format("YYYY-MM-DD") : "";
    let filters = cloneDeep(filteredInfo);
    if (startDate !== "" && endDate !== "") {
      filters = { ...filteredInfo, [item.dataIndex]: { type: item.type, displayName: item.displayName, value: [startDate, endDate] } };
    } else {
      delete filters[item.dataIndex];
    }
    handleFilters({ filters });
  };

  const handleEnter = (e : any) => {
    if(e.keyCode === 13) {
      e.stopPropagation();
    }
  }

  const handleReset = () => {
    setRange([]);
    if (inputref.current) {
      inputref.current.focus();
    }
  }

  return (
    <div>
      <div className="column_filter__date_picker" onKeyDown={(e) => handleEnter(e)}>
        <div className="reminderDateLabel">
          <span className="icon-calendar f18" />
        </div>
        <RangePicker
          ref={inputref}
          separator={<span className="range-picker-separator">-</span>}
          picker="date"
          size="large"
          autoFocus={true}
          format={dateFormatConfig.get(getClientName())["defaultDateFormat"]}
          allowClear={false}
          className='column_filter__date_input_selector'
          dropdownClassName="column_filter__date_popup"
          value={range?.[0] && range?.[1] ? [moment.utc(moment(range[0]).format("MM/DD/YYYY")), moment.utc(moment(range[1]).format("MM/DD/YYYY"))] : undefined}
          ranges={{
            "More Filters:": [null, null],
            "Last 1 Day": [moment.utc().subtract(1, "days"), moment.utc().subtract(1, "days")],
            "Last 7 Days": [moment.utc().subtract(7, "days"), moment.utc()],
            "Current Month to Date": [moment.utc(moment().startOf("month").format(getFormateForClient())), moment()],
          }}
          onChange={(range: any) => {
            setRange(range);
          }}
          onKeyDown={(e) => {
            if(e.keyCode === 13) {
              dateRangeChange()
            }
          }}
        />
      </div>
      <div className="column_filter__date__btn">
            <Button onClick={() => handleReset()} size="small" style={{ width: 90 }}> Reset </Button>
            <Button type="primary" icon={<SearchOutlined />} size="small" style={{ width: 90 }} onClick={() => dateRangeChange()}> Search </Button>
      </div>
    </div>
  );
};

//function component for date-time range filter
const DateTimeRange: FC<any> = ({ item, inputref ,filteredInfo, visible, handleFilters }: any) => {
  const value = get(filteredInfo , `${item.dataIndex}.value`);
  const [range, setRange] = useState<any>(value?.[0] && value?.[1] ? [moment.utc(formatDateWithoutConversion(value[0],'reminderDateActualFormat','dateTimeColumnFilterFormat')) , moment.utc(formatDateWithoutConversion(value[1],'reminderDateActualFormat','dateTimeColumnFilterFormat'))] : undefined);

  useEffect(() => {
    setRange(value?.[0] && value?.[1] ? [moment.utc(formatDateWithoutConversion(value[0],'reminderDateActualFormat','dateTimeColumnFilterFormat')) , moment.utc(formatDisplayDate(value[1],'reminderDateActualFormat','dateTimeColumnFilterFormat'))] : undefined);
  }, [value, visible]);

  const handleEnter = (e : any) => {
    if(e.keyCode === 13) {
      e.stopPropagation();
    }
  }

  const dateRangeChange = () => {
    const startDate = range && range.length > 0 ? formatDateWithoutConversion(range[0],'reminderDateActualFormat','dateTimeColumnFilterFormat') : "";
    const endDate = range && range.length > 0 ? formatDateWithoutConversion(range[1],'reminderDateActualFormat','dateTimeColumnFilterFormat') : "";
    let filters = cloneDeep(filteredInfo);
    if (startDate !== "" && endDate !== "") {
      filters = { ...filteredInfo, [item.dataIndex]: { type: item.type, displayName: item.displayName, value: [startDate, endDate] } };
    } else {
      delete filters[item.dataIndex];
    }
    handleFilters({ filters });
  };

  const handleReset = () => {
    setRange([]);
    if (inputref.current) {
      inputref.current.focus();
    }
  }

  return (
    <div>
      <div className="column_filter__date_picker" onKeyDown={(e) => handleEnter(e)}>
        <div className="reminderDateLabel">
          <span className="icon-calendar f18" />
        </div>
        <RangePicker
          ref={inputref}
          separator={<span className="range-picker-separator">-</span>}
          // picker="date"
          // size="large"
          autoFocus={true}
          showTime={{ format: 'HH:mm' }}
          format={dateFormatConfig.get(getClientName())["dateTimeColumnFilterDisplayFormat"]}
          allowClear={false}
          dropdownClassName="column_filter__date_popup"
          value={range?.[0] && range?.[1] ? [moment.utc(formatDateWithoutConversion(range[0],'reminderDateActualFormat','dateTimeColumnFilterFormat')) , moment.utc(formatDateWithoutConversion(range[1],'reminderDateActualFormat','dateTimeColumnFilterFormat'))] : undefined}
          ranges={{
            "More Filters:": [null, null],
            "Last 1 Day": [moment.utc().subtract(1, "days").utcOffset(0).set({hour:0,minute:0}), moment.utc().subtract(1, "days").utcOffset(0).set({hour:23,minute:59})],
            "Last 7 Days": [moment.utc().subtract(7, "days").utcOffset(0).set({hour:0,minute:0}), moment.utc().utcOffset(0).set({hour:23,minute:59})],
            "MTD": [moment.utc(moment().startOf("month").format(getFormateForClient())).utcOffset(0).set({hour:0,minute:0}), moment.utc().utcOffset(0).set({hour:23,minute:59})],
          }}
          onChange={(range: any) => {
            setRange(range);
          }}
          onKeyDown={(e) => {
            if(e.keyCode === 13) {
              dateRangeChange()
            }
          }}
        />
      </div>
      <div className="column_filter__date__btn">
            <Button onClick={() => handleReset()} size="small" style={{ width: 90 }}> Reset </Button>
            <Button type="primary" icon={<SearchOutlined />} size="small" style={{ width: 90 }} onClick={() => dateRangeChange()}> Search </Button>
      </div>
    </div>
  );
};

export const CustomDate = ({item, inputref , filteredInfo, visible, handleFilters} : any) => {
  const [date , setDate] = useState(get(filteredInfo , `${item.dataIndex}.value` , ''));
  const [ref, setref] = useState<any>();
  /*on close and opening of dropdown the below useEffect will run and the input will be set in the filter Input*/
  useEffect(() => {
    setDate(get(filteredInfo , `${item.dataIndex}.value` , ''));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const handleDateSearch = () => {
    let filters = cloneDeep(filteredInfo);
    if (date && !date.includes('_') && moment(date, 'MM/DD/YYYY').isValid()) {
      filters = { ...filteredInfo, [item.dataIndex]: { type: item.type, displayName: item.displayName, value: [date] }};
    } else {
      delete filters[item.dataIndex];
    }
    handleFilters({ filters });
  }

  const handleDateChange = (e : any) => {
    if(e.keyCode === 13) {
      e.stopPropagation();
    } else {
      setDate(e.target.value)
    }
  }

  const handleReset = () => {
    setDate('')
    ref?.focus();
  }

  const handleEnter = (e : any) => {
    if(e.keyCode === 13) {
      e.stopPropagation();
    }
  }

  return (
    <div onKeyDown={(e) => handleEnter(e)}>
      <InputMask
        mask="99/99/9999"
        // maskChar={null}
        // maskPlaceholder={"mm/dd/yyyy"}
        placeholder={"mm/dd/yyyy"}
        className="ant-input member-item"
        value={date}
        onChange={(e) => handleDateChange(e)}
        inputRef={(ref) => {
          setref(ref);
        }}
        onKeyDown={(e) => {
          if (e.keyCode === 13) {
            handleDateSearch();
          }
        }}
      />
      <div className="column_filter__criteria__btn">
        <Button onClick={() => handleReset()} size="small" style={{ width: 90 }}>
          {" "}
          Reset{" "}
        </Button>
        <Button type="primary" icon={<SearchOutlined />} size="small" style={{ width: 90 }} onClick={() => handleDateSearch()}>
          {" "}
          Search{" "}
        </Button>
      </div>
    </div>
  );
};

export const DateInputMask = ({item, inputref , filteredInfo, visible, handleFilters} : any) => {

  useEffect(() => {
    setDate(get(filteredInfo , `${item.dataIndex}.value` , ''));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const [date, setDate] = useState(get(filteredInfo , `${item.dataIndex}.value` , ''));

  const handleDateChange = (e : any) => {
    if(e.keyCode === 13) {
      e.stopPropagation();
    } else {
      const formattedDate = formatDateString(e.target.value);
      setDate(formattedDate);
    }
  };

  const formatDateString = (value : string) => {
    const cleanedValue = value.replace(/\D/g, '');
    const match = cleanedValue.match(/^(\d{0,2})(\d{0,2})(\d{0,4})$/);

    if (!match) return '';

    const month = match[1] ? `${match[1]}` : '';
    const day = match[2] ? `/${match[2]}` : '';
    const year = match[3] ? `/${match[3]}` : '';

    return `${month}${day}${year}`;
  };

  const handleDateSearch = () => {
    let filters = cloneDeep(filteredInfo);
    if (date) {
      if(moment(date, 'MM/DD/YYYY' , true).isValid()) {
        filters = { ...filteredInfo, [item.dataIndex]: { type: item.type, displayName: item.displayName, value: [date] }};
      } else {
        notification.error({
          message: "Error",
          description: "Please enter a valid Date",
        });
        return;
      }
    } else {
      delete filters[item.dataIndex];
    }
    handleFilters({ filters });
  }

  const handleReset = () => {
    setDate('')
    if (inputref.current) {
      inputref.current.focus();
      setDate('');
    }
  }


  const handleEnter = (e : any) => {
    if(e.keyCode === 13) {
      e.stopPropagation();
    }
  }


  return (
    <div  onKeyDown={(e) => handleEnter(e)}>
    {/* <input
      ref={inputref}
      type="text"
      value={date}
      onChange={handleDateChange}
      placeholder="mm/dd/yyyy"
    /> */}
    <Input
    className={'column_filter__customdate'}
        ref={inputref}
        style={{ marginBottom: 8, display: "block" }}
        value={date}
        // disabled={noData}
        placeholder={`mm/dd/yyyy`}
        onChange={(e) => {
          handleDateChange(e)
        }}
        onPressEnter={(e) => {
          e.stopPropagation();
          handleDateSearch();
        }}
      />
    <div className="column_filter__criteria__btn">
        <Button onClick={() => handleReset()} size="small" style={{ width: 90 }}>
          {" "}
          Reset{" "}
        </Button>
        <Button type="primary" icon={<SearchOutlined />} size="small" style={{ width: 90 }} onClick={() => handleDateSearch()}>
          {" "}
          Search{" "}
        </Button>
  </div>
  </div>
  );
};

//function component for multi dropdown filter
const MultiDropdownFilter = ({ item, filterDropdowns, filteredInfo = {}, setFilteredInfo, columns, getTableData, visible, handleFilters }: any) => {
  const [selected, setSelected] = useState<Array<any>>(get(filteredInfo , `${item.dataIndex}.value` , []));
  const [options, setOptions] = useState(get(filterDropdowns , `${item.dropdown_key}` , []));

  useEffect(() => {
    setSelected(get(filteredInfo , `${item.dataIndex}.value` , []));
  }, [filteredInfo, item.dataIndex, visible]);

  const onSearch = (freeText: any) => {
    let temp = get(filterDropdowns , `${item.dropdown_key}` , []).filter((item: any) => {
      return !selected.includes(item.value || "") && item.value.toLowerCase().includes(freeText.toLowerCase());
    });
    temp = [...selected, ...temp];
    setOptions(temp);
  };

  const handleOK = () => {
    const filters = cloneDeep(filteredInfo);
    if (selected.length > 0) {
      filters[item.dataIndex] = { type: item.type, displayName: item.displayName, value: selected };
    } else {
      delete filters[item.dataIndex];
    }
    handleFilters({ filters });
  };

  return (
    <div>
      <Input onChange={(e) => onSearch(e.target.value)} allowClear={true}  onPressEnter={(e) => e.stopPropagation()} className="inputForSearchFilter" placeholder={`Search ${get(item , 'displayName' , "")}`} />
      <Checkbox.Group
        value={selected}
        options={options}
        onChange={(selectedArray) => {
          setSelected(selectedArray);
        }}
        className={`${options?.length > 5 ? "column_filter__dropdown custom-scroll-bar" : "providerType"}`}
      />
      <div className="column_filter__criteria__btn">
            <Button onClick={() => setSelected([])} size="small" style={{ width: 90 }}> Reset </Button>
            <Button type="primary" icon={<SearchOutlined />} size="small" style={{ width: 90 }} onClick={() => handleOK()}> Search </Button>
      </div>
    </div>
  );
};

//function to return the count of filtered columns
export const filterCount = ({ filteredInfo = {}}: any) => {
  return Object.values(filteredInfo).filter((filter: any) => get(filter , `value[0].filterValues`) ? get(filter , `value[0].filterValues`).length : get(filter , `value`).length).length;
};

//component to show the no of columns has filters
export const FilterCountBtn = ({className='' ,filteredInfo = {}, showFilters = true, setShowFilters = noop }: any) => {
  const appliedFiltersCount = filterCount({ filteredInfo});

  return appliedFiltersCount > 0 ? (
    <div className={`filter-count-btn ${className}`} onClick={() => setShowFilters(!showFilters)}>
      <Icon name="funnel" />
      <span>Filters {`(${appliedFiltersCount})`}</span>
      <span className="filter-count-btn__arrows">
        <UpOutlined rotate={showFilters ? 180 : 0} className="filter-count-btn__arrows--icon" />
        <DownOutlined rotate={showFilters ? 180 : 0} className="filter-count-btn__arrows--icon" />
      </span>
    </div>
  ) : (
    <></>
  );
};

//component to show the applied filters and remove them
export const ClearFilters: FC<any> = ({
  filteredInfo = {},
  setFilteredInfo = noop,
  getFilteredTableData = noop,
  showFilters = true,
  resetFilterPage = noop,
}: any) => {
const { disableScroll, enableScroll } = usePreventBodyScroll();
  const removeFilter = ({ key }: { key: string }) => {
    const filters = cloneDeep(filteredInfo);
    if (key in filters) {
      delete filters[key];
      setFilteredInfo(filters);
      resetFilterPage({ });
    }
    getFilteredTableData({ filters: filters , page : 1});
  };

  const clearAllFilters = () => {
    setFilteredInfo({});
    getFilteredTableData({ filters: {},  page : 1});
    resetFilterPage({});
  };

  return filterCount({ filteredInfo}) > 0 ? (
    <div className={`clear-filters ${showFilters ? "slide-out" : ""}`} >
      <div className='clear-filters__list' onMouseEnter={disableScroll} onMouseLeave={enableScroll}>
      <ScrollMenu LeftArrow={LeftArrow} RightArrow={() => RightArrow()} onWheel={onWheel}>
        {Object.keys({ ...filteredInfo }).map((key: any) => {
          let { displayName, value , type} = { ...filteredInfo }[key];
          let criteria;
          if (value?.[0]?.filterValues) {
            criteria = value?.[0]?.filterType;
            value = value?.[0]?.filterValues;
          } else if([DATE , DATETIME].includes(type)){
            criteria = 'Between';
          }
          return (
            <Tooltip
              placement="bottom"
              title={
                <span>
                  {`${displayName} : `}
                  <span>{`${value?.join(", ") || ""} `}</span>
                </span>
              }
            >
              <div className="clear-filters__list__filter">
                <div className="clear-filters__list__filter__label">{`${displayName} : `}</div>
                <div className="clear-filters__list__filter__value">
                  {criteria ? `${criteria} ( ${value?.join(", ") || ""} )` : value?.length > 1 ? `${value?.[0]} , +${value?.length - 1} more` : value?.join(", ") || ""}
                </div>
                <div className="clear-filters__list__filter__close">
                  <CloseOutlined onClick={() => removeFilter({ key })} />
                </div>
              </div>
            </Tooltip>
          );
        })}
      </ScrollMenu>
      </div>
      <div className="clear-filters--btn" onClick={() => clearAllFilters()}>
        Clear All
      </div>
    </div>
  ) : (
    <></>
  );
};

//function component to decide which type of filter should be rendered for column based on type
export const ColFilters: FC<any> = (props: any) => {
  const { item, filteredInfo, setFilteredInfo, resetFilterPage = noop, getTableData, confirm = noop} = props;
  const handleFilters = ({ filters }: any) => {
    if (JSON.stringify(filters[item.dataIndex]) !== JSON.stringify(filteredInfo[item.dataIndex])) {
      setFilteredInfo(filters);
      getTableData({ filters: filters , page : 1});
      resetFilterPage({});
    }
    confirm({ closeDropdown: true });
  };
  
  let filterComp = <></>
  if (item.type === FREETXT) {
    filterComp  = <FreeText {...props} handleFilters={handleFilters} />;
  } else if (item.type === DATE) {
    filterComp  = <DateRange {...props} handleFilters={handleFilters} />;
  } else if ([CRITERIA, DOLLAR_CRITERIA].includes(item.type)) {
    filterComp  = <Criteria {...props} handleFilters={handleFilters} />
  } else if (item.type === MSELDRPDWN) {
    filterComp  = <MultiDropdownFilter {...props} handleFilters={handleFilters} />
  } else if (item.type === DATETIME) {
    filterComp  = <DateTimeRange {...props} handleFilters={handleFilters} />;
  } else if (item.type  === CUSTOM_DATE) {
    // filterComp  = <CustomDate {...props} handleFilters={handleFilters} />;
    filterComp  = <DateInputMask {...props} handleFilters={handleFilters} />;
  }

  return <div style={{ padding: "10px" }} className="filtersPanel">{filterComp}</div>
};

//modal to show if the user is trying to remove the column which has filters applied
export const FilterColumnRemoval: FC<any> = (props: any) => {
  const { isModalOpen, handleOk, handleCancel, colNames = [], action } = props;

  return (
    <Modal wrapClassName="custom-action-modal" title={"Are you sure ?"} centered visible={isModalOpen} footer={false} zIndex={2000}>
      <>
        {action === "resetAll" ? (
          <>
            <p className="filter_modal_content">
              <span>{`You are about to Reset All the Columns in all Layouts`}</span>
            </p>
            <p className="filter_modal_content__sub">
              <span>{`(Applied Column Filters will be removed)`}</span>
            </p>
          </>
        ) : action === "adtClick" ? (
          <>
            <p className="filter_modal_content">
              <span>{`You're about to switch registry, which has hidden columns where filters have been applied.`}</span>
            </p>
            <p className="filter_modal_content__sub">
              <span>{`(You will be able to access all filters in the filters list)`}</span>
            </p>
            {colNames.length > 0 && <p>{`${colNames.join(", ")} has Applied Filters`}</p>}
          </>
        ) : (
          <>
            <p className="filter_modal_content">
              <span>{`You are about to remove a Column which has filters applied`}</span>
            </p>
            <p className="filter_modal_content__sub">
              <span>{`(You will be able to access all filters in the filters list)`}</span>
            </p>
            {colNames.length > 0 && <p>{`${colNames.join(", ")} has Applied Filters`}</p>}
          </>
        )}

        <p>
          <div className="filter_modal_btn">
            <Button size="large" className="f16 w500 filter_modal_btn--cancel" onClick={() => handleCancel()}>
              {"Cancel"}
            </Button>
            <Button type="primary" size="large" className="f16 w500" onClick={() => handleOk()}>
              {`Yes, ${action === "adtClick" ? `Switch Registry` : action === "resetAll" ? `Reset All` : `Remove Column`}`}
            </Button>
          </div>
        </p>
      </>
    </Modal>
  );
};

//function to format filter data for to send to api
export const formatFilterDataForApi = (filterData: any) => {
  const filters = [];
  for (const [key, filter] of Object.entries<any>(filterData)) {
    if ([CRITERIA, DOLLAR_CRITERIA].includes(filter.type) && filter.value[0].filterType && filter.value[0].filterType !== "Deselect") {
      filters.push({ filterType: key, filterValues: filter.value, colType: filter.type });
    } else if ([MSELDRPDWN, DATE,DATETIME].includes(filter.type)) {
      filters.push({ filterType: key, filterValues: filter.value, colType: filter.type });
    } else if([CUSTOM_DATE].includes(filter.type)) {
      filters.push({ filterType: key, filterValues: [moment(filter.value[0], 'MM/DD/YYYY').format('YYYY-MM-DD')], colType: filter.type });
    } else if (filter.type === FREETXT) {
      filters.push({ filterType: key, filterValues: filter.value?.[0], colType: filter.type });
    }
  }
  return filters;
};

//This middleware function will check filters if the all applied filter columns are present in upcoming columns the okfunc will get executed
export const colFilterMiddleWare = (func: any, funcParams: any, okfunc: any) => {
  if (func) {
    if (!func({ ...funcParams, onOk: okfunc })) {
      okfunc();
    }
  } else {
    okfunc();
  }
};

export const FilterIcon = ({filteredInfo = {}, item = {}} : any) => {
  if (item.dataIndex === 'worked_upon_date') {
    return <></>
  }
  return [DATE, CRITERIA,DOLLAR_CRITERIA,MSELDRPDWN,DATETIME].includes(item.type) ? (
    <Icon name="funnel" colorOfBrand={get(filteredInfo, [CRITERIA, DOLLAR_CRITERIA].includes(item.type) ? `${item.dataIndex}.value[0].filterValues` : `${item.dataIndex}.value`, "").length > 0
          ? "#ef6d2a"
          : ""}/>
  ) : (
    <SearchOutlined className={(get(filteredInfo, `${item.dataIndex}.value[0]`, "") !== "" ? "table-filter-active" : "")+ ' column_filter--icon'} />
  )
}

export const getDropdownFilters = ({colData = []}) => {
  const dropdownFilters : any = [];
  colData.forEach((item: any) => {
    if(item.type === MSELDRPDWN && !dropdownFilters.includes(item.dropdown_key)) {
      dropdownFilters.push(item.dropdown_key);
    }
  })
  return dropdownFilters;
}

export const isFiltered = ({filters = {} , dataIndex = '' , subColumns = []}) => {
  return Object.keys(filters).includes(dataIndex) || subColumns.find((col : any) => Object.keys(filters).includes(col.dataIndex));
}

// custom hook to export column filter related functions
export const useColumnFilters = () => {
  return { filterCount, colFilterMiddleWare , getDropdownFilters};
};

export const SortIcon = ({item , pageName : appPage, handleChange} : any) => {
  
  const {handleSort , order , columnKey} = useSorter(appPage , item , handleChange);

  return (
  <span className={`table-col-sorter table-col-sorter-${item.dataIndex}`} style={{display : 'flex' , flexDirection : 'column', height: '1.8rem' , cursor : 'pointer'}}>
      <span onClick={() => handleSort('ascend')} style={{ height: '11px' }}>
        <Icon name="sortUpArrow"  height={'11'} colorOfBrand ={order === 'ascend' && item.dataIndex === columnKey ? '#EF6D2A' : ''}/>
      </span>
      <span onClick={() => handleSort('descend')} style={{ height: '11px' }}>
        <Icon name="sortDownArrow" height={'11'} colorOfBrand ={order  === 'descend' && item.dataIndex === columnKey  ? '#EF6D2A' : ''}/>
      </span>
    </span>
  );
}

export const SortHeader = React.memo(({item , pageName , handleData} : any) => {
  console.log('Colfilters.SortHeader')
  return <span style={{display : 'flex' , justifyContent: 'space-between', alignItems: 'center'}}><span style={{width: '90%', textAlign: 'center'}}>{item.tableHeaderName || item.title}</span><span><SortIcon item={item} pageName={pageName} handleChange={(sorter : any) => handleData(sorter)}/></span></span>;
})

function onWheel(apiObj: scrollVisibilityApiType, ev: React.WheelEvent): void {
  const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;

  if (isThouchpad) {
    ev.stopPropagation();
    return;
  }

  if (ev.deltaY < 0) {
    apiObj.scrollNext();
  } else if (ev.deltaY > 0) {
    apiObj.scrollPrev();
  }
}